import * as actions from "./actions";
import { SERVER_URL } from "constants/index";

const setCartIdInLocalStorage = newState => {
  sessionStorage.setItem("cartId", newState);
};

const getGuestCartProducts = cartId => {
  return dispatch => {
    fetch(SERVER_URL + `guest-carts/${cartId}/items`)
      .then(response => response.json())
      .then(json => {
        dispatch(actions.getGuestCartProducts(json));
        dispatch(calculateCartPriceAndQty(json));
      })
      .catch(error => console.error(error));
  };
};

const setGuestCartId = cartId => dispatch => {
  dispatch(actions.getGuestCartId(cartId));
};

const calculateCartPriceAndQty = currentCartState => dispatch => {
  let cartPrice = 0;
  let cartQty = 0;

  currentCartState.forEach(product => {
    cartPrice += product.qty * product.price;
    cartQty += product.qty;
    return true;
  });

  dispatch(actions.setCartPriceAndQty(cartPrice, cartQty));
};

const getGuestCartId = () => {
  return dispatch => {
    fetch(SERVER_URL + "guest-carts", {
      method: "POST"
    })
      .then(response => response.json())
      .then(json => {
        setCartIdInLocalStorage(json);
        dispatch(setGuestCartId(json));
        dispatch(getGuestCartProducts(json));
      });
  };
};

export {
  getGuestCartId,
  setGuestCartId,
  getGuestCartProducts,
  calculateCartPriceAndQty
};



// WEBPACK FOOTER //
// ./src/modules/Cart/actions/operations.js